import {useOptionalChatbotModalContext} from 'app/pages/chatbot/hooks/ChatbotModalContext'
import {isFaqChatbotEnabled} from 'common/HelperFunctions'
import {MouseEvent, ReactNode, useState} from 'react'
import {useNavigate} from 'react-router'
import SupportChoiceModal from './SupportChoiceModal'

/**
 * Switch: `true` — "Need Any Support?" asks first (Versi or a support ticket).
 * `false` — the old flow: it opens Versi straight away.
 */
const SUPPORT_CHOICE_MODAL_ENABLED = true

const CREATE_TICKET_PATH = '/institute/support-tickets/create'

/**
 * Click handler for every "Need Any Support?" link. With the FAQ chatbot on it opens the
 * Versi-or-ticket chooser (or Versi directly when the switch is off); otherwise it does
 * nothing and the link's href to the support tickets page applies. Render `supportChoiceModal`
 * next to the link.
 */
const useSupportEntry = (): {
  onSupportClick: (event: MouseEvent<HTMLAnchorElement>) => void
  supportChoiceModal: ReactNode
} => {
  const navigate = useNavigate()
  // Nullable on purpose: the header must not hard-depend on the chatbot provider.
  const chatbotModal = useOptionalChatbotModalContext()
  const [showChoice, setShowChoice] = useState(false)

  const onSupportClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (!chatbotModal || !isFaqChatbotEnabled()) return
    event.preventDefault()
    if (SUPPORT_CHOICE_MODAL_ENABLED) setShowChoice(true)
    else chatbotModal.openChatbot()
  }

  // Mounted only while open, so pages that never open it carry no modal (or its intl lookups).
  const supportChoiceModal = showChoice && (
    <SupportChoiceModal
      show
      onHide={() => setShowChoice(false)}
      onAskVersi={() => {
        setShowChoice(false)
        chatbotModal?.openChatbot()
      }}
      onCreateTicket={() => {
        setShowChoice(false)
        navigate(CREATE_TICKET_PATH)
      }}
    />
  )

  return {onSupportClick, supportChoiceModal}
}

export default useSupportEntry
